import { graphql, useStaticQuery } from 'gatsby';
import {
	ConfigurationModel,
	Consent,
	Program,
} from '../components/hoc/context/product/configuration-model';
import useMock from './useMock';


export type Configuration = {
	params: { [key: string]: string};
	territories:string[];
	programs: Program[];
	consents: Consent[];
};

export default function useProduct(): ConfigurationModel {
	const mock = useMock();
	const { config } = useStaticQuery<{ config: Configuration }>(graphql`
		query productConfigurationQuery {
			config: productConfiguration {
				params {
					brandName
					programName
					phoneNumber
					brandPhoneDisplay
					workingHours
					workingDays
					workingHolidays
					copayAmount
					copayCap
					cardOffer
					ftoDays
					website
					currency
					mlrVersion
				}
  				territories
				programs {
					title
					services {
						name
						legal
						consents {
							explicit
						}
						elegibility {
							patient {
								id
								operator
								value
							}
							caregiver {
								id
								operator
								value
							}
							questions {
								id
								operator
								value
							}
						}
						static
					}
				}
				consents {
					id
					channel
				}
			}
		}
	`);

	config?.programs?.forEach((program) => {
		program.services?.forEach((service) => {
			// filter out empty explicit consent records
			if (service.consents?.explicit) {
				service.consents.explicit = service.consents.explicit.filter(
					(explicitValue) => {
						return explicitValue;
					}
				);
			}
			// filter out empty eligibility records
			if (service.elegibility?.caregiver) {
				service.elegibility.caregiver = service.elegibility.caregiver.filter(
					(rule) => {
						return rule.id;
					}
				);
			}
			if (service.elegibility?.patient) {
				service.elegibility.patient = service.elegibility.patient.filter(
					(rule) => {
						return rule.id;
					}
				);
			}
			if (service.elegibility?.questions) {
				service.elegibility.questions = service.elegibility.questions.filter(
					(rule) => {
						return rule.id;
					}
				);
			}
			// fill static service with mock data if exists
			if (service.static) {
				const mockData = mock.connector.data.find(
					(data) => service.name === data.service
				);
				if (mockData) {
					service.static = mockData.card;
				}
			}
		});
	});

	return new ConfigurationModel(config);
}
